import React, { useEffect, useState, useContext } from 'react';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import { Context } from '../../../context/UserContext';
import Form from './Form';
import styles from '../../form/Form.module.css';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';

import * as EmpresaAPI from '../../../api/empresa';
import CRUDsAPI from '../../../api/CRUDs';

import { resolveEmpresaTabela } from '../../../utils/funcoes';

import { getEmpresaScope } from '../../../helpers/sessionEmpresa';
import { set } from 'date-fns';

const CreateOrEdit = () => {
    const { empresaId, empresaIds } = getEmpresaScope();
    const [dados, setDados] = useState({
        empresaId: empresaId,
        ativo: true,
    });
    //tabelas filhas
    const [NCM, setNCM] = useState({});

    const [token] = useState(localStorage.getItem('token')) || '';
    const { parametro } = useContext(Context);
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);

    const empresaTabelaId = resolveEmpresaTabela(parametro, empresaId);

    const pathname = '/Tributacao';
    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText');

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    //enums e tabelas
    const [OptionsEmpresa, setEmpresa] = useState([]);

    useEffect(() => {
        if (!token) {
            return navigate('/Auth', { replace: true });
        }

        //carregar API's Externas
        const consultaEmpresa = async () => {
            let dados = await EmpresaAPI.empresa(empresaId);
            setEmpresa(dados);
        };
        consultaEmpresa();

        if (uuid && uuid !== 'null') {
            CRUDsAPI.tributacao
                .consulta(uuid)
                .then((response) => {
                    setDados(response.data);
                    setNCM(response.data?.NCM || {});
                })
                .catch((error) => {
                    console.error(error);
                    setFlashMessage(error.response.data.message, error.response.data.type);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, uuid]);

    async function managerDados(dados) {
        let urlNavigate = pathname;

        try {
            let response;

            if (uuid && uuid !== 'null') {
                response = await CRUDsAPI.tributacao.editar(dados);
            } else {
                response = await CRUDsAPI.tributacao.cadastrar(dados);

                if (response.status === 202) {
                    setDados(response.data);
                    response.data.message = 'Registro em duplicidade!';
                    response.data.type = 'warning';
                    urlNavigate = pathname + '/CreateOrEdit';
                    params.set('uuid', response.data.uuid);
                    params.set('btnText', 'Atualizar');
                }
            }
            setFlashMessage(response.data.message, response.data.type);

            setTimeout(() => {
                navigate(urlNavigate, params);
            }, parametro.msgTempo * 1000);
        } catch (error) {
            console.error(error);
            setFlashMessage(error.response.data.message, error.response.data.type);
        }
    }

    return (
        <section className={`${styles.form_container} ${styles[parametro.tema]}`}>
            <Form
                token={token}
                dados={dados}
                setDados={setDados}
                NCM={NCM}
                setNCM={setNCM}
                handleSubmit={managerDados}
                parametro={parametro}
                btnText={btnText}
                OptionsEmpresa={OptionsEmpresa}
                caminhoVoltar={pathname}
                empresaId={empresaId}
                empresaIds={empresaIds}
                empresaTabelaId={empresaTabelaId}
            />
        </section>
    );
};
export default CreateOrEdit;
